import { useIntl } from 'react-intl'
import { formatStyles } from '../../../../../components/react-intl-helpers'
import { getCurrentLanguage, getLanguageInfo } from '../common/utils'
import { stepAgentConfig } from './common'

export const onboardViaDocsAgentWizardSteps = [
  {
    defaultIsOpen: true,
    ...stepAgentConfig
  },
  {
    titleMsg: 'title_gotoContrastDocs',
    defaultIsOpen: true,
    Content: () => {
      const intl = useIntl()
      const langInfo = getLanguageInfo(getCurrentLanguage())

      return intl.formatMessage(
        { id: 'detail_gotoContrastDocs' },
        {
          language: intl.formatMessage({ id: langInfo?.titleMsg }),
          ...formatStyles.doclink({ path: langInfo?.doclink })
        }
      )
    }
  }
]
